export default "__VITE_ASSET__i$tAw6l1__"